import styled from "styled-components";

const Text = styled.p`
  font-size: 20px;
  line-height: 26px;
  font-weight: 200;
  margin: 0;
  color: #222;
  width: 420px;
  padding-left: 120px;

  @media (max-width: 1199.98px) {
    font-size: 17px;
    line-height: normal;
    width: 370px;
    padding-left: 40px;
  }
  @media (max-width: 767px) {
    font-size: 12px;
    width: 150px;
    background: #fff;
    padding: 10px;
    border-radius: 10px;
  }
`;
export default Text;
